<template>
  <div class="login-wrapper-box" :style="{
      backgroundImage: 'url(' + bgImage + ')',
    }">
    <div class="main-content h-100">
      <div class="auth-layout-wrap position_wrapper">
        <div class="card login-wrapper">
          <div class="p-4">
            <!-- 注册类型 -->
            <div class="form-group col-md-6 mb-3">
              <label for="input-1">注册类型</label>
              <b-form-select
                type="text"
                v-model="zhucetype"
                :options="typedata"
                @change="typechange"
              ></b-form-select>
            </div>
            <!-- 姓名 -->
            <div class="form-group col-md-6 mb-3">
              <b class="ColorRed">*</b>
              <label for="input-1">姓名</label>
              <b-row>
                <b-col md="12">
                  <b-form-input
                    placeholder="请输入姓名"
                    required
                    v-model="form.userName"
                    class="input"
                    id="input-live"
                    aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
            <!-- 身份证号 -->
            <div class="form-group col-md-6 mb-3">
              <b class="ColorRed">*</b>
              <label for="input-1">身份证号</label>
              <b-row>
                <b-col md="12">
                  <b-form-input
                    placeholder="请输入身份证号"
                    required
                    v-model="form.code"
                    class="input"
                    id="input-live"
                    aria-describedby="input-live-help input-live-feedback"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: "signIn"
  },
  data() {
    return {
      zhucetype: "招商顾问", //默认类型为招商顾问
      typedata: [
        {
          text: "招商顾问",
          value: "招商顾问"
        },
        {
          text: "平台用户",
          value: "平台用户"
        }
      ],
      bgImage: require("@/assets/newindex/newlogin.jpg"),
      form: {
        //招商顾问
        tel: "",
        userName: "",
        code: "",
        email: "",
        businessOrg: "", //招商顾问的单位
        password: "",
        password1: "",
        checkCode: "",
        messageCheckCode: ""
      },
      form2: {
        //平台用户
        tel: "",
        userName: "",
        code: "",
        email: "",
        orgId: 0, //平台用户的单位
        password: "",
        password1: "",
        checkCode: "",
        messageCheckCode: "",
        posinion: "" //平台用户的职务
      }
    };
  },
  watch: {},

  methods: {
    zhuce() {
      console.log(1);
      this.$router.push({
        name: "zhuce"
      });
    },
    typechange(val) {
      console.log(val, 8888);
      this.zhucetype = val;
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.title_color {
  color: #ced4da;
  position: relative;
}
.size_10 {
  font-size: 10px;
}
.login_color {
  background: rgb(200, 0, 11) !important;
}
.sendCode_color {
  background: rgb(102, 51, 152) !important;
}
.font-weight-bold {
  color: #ffffff !important;
}
.card {
  border: none !important;
}
.font-weight-bold::after {
  content: "";
  position: absolute;
  width: 64px;
  height: 2px;
  background: white;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.login-wrapper-box {
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  .position_wrapper {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .login-wrapper {
    background: #ffffff;
    width: 300px;
    height: 470px;
    margin: 114px auto 0px;
  }
}
</style>


